import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

export const PlaceOfBirthType = () => {
    const { chartData } = useProfileChartsDataContext();

    return (
        <Donut
            title={'Naturalidade'}
            subtitles={chartData?.placeOfBirthType?.map(
                (item) => item.description
            )}
            chartData={chartData?.placeOfBirthType || []}
            colors={
                defaultColors.slice(0, chartData?.placeOfBirthType?.length) ||
                []
            }
            height={400}
            className="aligned-container"
        />
    );
};
